import {lazy, Suspense, useMemo} from "react";
import {Link} from 'react-router-dom';
import {CrudFilterFieldTypes, CrudFilterOperator, ICrudFilter} from "../../dimijs/src/lib/sources/source";
import {IPage} from '../../sources/types';
import {Base} from '../../dimijs/src/lib/components/lists/Base';
import {getPageSource} from '../../sources/pageSource';
import {DataCtx} from '../../dimijs/src/lib/utils/dataContext';
import {useContext} from 'react';

interface CpPageProps {
  children?: React.ReactNode;
  title?: string;
  top_right_component?: string;
}

export const CpPage = (props: CpPageProps) => {
  const {store} = useContext(DataCtx);

  const filter_menu = useMemo(() => {
    return [{
      operator: CrudFilterOperator.LIKE,
      field: 'resolve',
      value: '/cp',
      type: CrudFilterFieldTypes.Field
    }] as ICrudFilter<IPage>[];
  }, []);

  const pagination = useMemo(
    () => ({page: 0, countOnPage: 50}),
    []
  );

  const pagesSource = getPageSource(store);
  const title = props.title || 'PushApp Fit';

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      {/* Top bar */}
      <header style={{
        borderBottom: '1px solid #e5e7eb',
        backgroundColor: 'white',
      }}>
        <div style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '1rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <nav style={{ display: 'flex', alignItems: 'center', gap: '1.5rem' }}>
            <span style={{ fontWeight: 600, fontSize: '1.125rem' }}>{title}</span>
            <Base
              source={pagesSource.source}
              filter={filter_menu}
              pagination={pagination}
              RowTemplate={rowTemplateProps => {
                return (
                  <Link
                    to={rowTemplateProps.item.url}
                    style={{
                      fontSize: '0.875rem',
                      fontWeight: 500,
                      color: window.location.pathname === rowTemplateProps.item.url ? '#7c3aed' : '#6b7280',
                      textDecoration: 'none',
                      transition: 'color 0.15s',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#111827'}
                    onMouseLeave={(e) => {
                      if (window.location.pathname !== rowTemplateProps.item.url) {
                        e.currentTarget.style.color = '#6b7280';
                      }
                    }}
                  >
                    {rowTemplateProps.item.title}
                  </Link>
                );
              }}
            />
          </nav>

          {/* Top-right lazy component placeholder */}
          {props.top_right_component && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <Suspense fallback={<div>Loading...</div>}>
                {(() => {
                  const Component = lazy(() => import(`../${props.top_right_component}`));
                  return <Component />;
                })()}
              </Suspense>
            </div>
          )}
        </div>
      </header>

      {/* Page content */}
      <main style={{
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '1.5rem 1rem',
      }}>
        {props.children}
      </main>
    </div>
  );
};
